<template>
    <div>
        <label :for="id">{{label}}</label>
        <input :value="value"
               @input="$emit('input',$event.target.value)"
               @keypress="$emit('keypress')"
               @keyup="$emit('keyup')"
               @change="$emit('change')"
               @focus="$emit('focus')"
               @focusout="$emit('focusout')"
               @blur="blur"
               :autofocus="autofocus"
               :required="required"
               :disabled="disabled"
               autocomplete="off"
               type="text"
               :name="name"
               :id="id"
               :placeholder="placeholder"
        >
        <i class="bar"></i>
    </div>
</template>

<script>
    export default {
        name: "inputComp",
        props: {
            placeholder: String,
            name: String,
            value: '',
            id: String,
            label: String,
            required: Boolean,
            autofocus: Boolean,
            disabled: Boolean
        },
        methods:{
            keypress(){
                this.$emit('keypress')
            },
            blur(){
                this.$emit('blur')
            }
        }
    }
</script>

<style scoped lang="scss">
    div {

        label {
            font-weight: bold;
        }

        input {
            width: 100%;
            text-transform: uppercase;
        }

    }
</style>
